<template>
	<img :src="src" v-if="show" :style="styles" @click="clicked($event)" :class="{'clickable': !!settings.click}" />
</template>

<script>
	export default {
		name: "TableImage",
		props: ["settings"],
		data() {
			return {};
		},
		computed: {
			src() {
				return this.settings.src;
			},
			show() {
				return typeof this.settings.hide === "undefined" || this.settings.hide === false;
			},
			styles() {
				return typeof this.settings.styles === "undefined" ? "" : this.settings.styles;
			},
		},
		methods: {
			clicked(e) {
				if (this.settings.click) {
					e.preventDefault();

					this.$emit( 'clicked', null );
				}
			},
		},
	};
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
.clickable {
	cursor: pointer;
}
</style>